import FavoritesEmpty from "./FavoritesEmpty.tsx";
import DefaultTemplate from "../layout/content-templates/default/DefaultTemplate.tsx";
import { useFavoritesLoader } from "./favorites.ts";
import { useIntl } from "react-intl";
import ResponsiveAssetListAuto from "../../../common/features/asset/ResponsiveAssetListAuto.tsx";
import { useRef } from "react";
import React from "react";
import DotLoader from "../../../common/core-ui/DotLoader.tsx";
import { Await } from "react-router-dom";
import DefaultError from "../../../common/core-ui/DefaultError.tsx";
import AssetCard from "../common/cards/AssetCard.tsx";
import PageTitle from "../common/page-title/PageTitle.tsx";

export default function Favorites() {
  const data = useFavoritesLoader();
  const firstCardRef = useRef<HTMLLIElement>(null);
  const intl = useIntl();
  const title = intl.formatMessage({ defaultMessage: "Favorites" });

  return (
    <DefaultTemplate title={title}>
      <PageTitle title={title} />
      <React.Suspense fallback={<DotLoader />}>
        <Await resolve={data.favorites} errorElement={<DefaultError />}>
          {(
            favoritesResult: Awaited<
              ReturnType<typeof useFavoritesLoader>["favorites"]
            >
          ) => {
            const favorites = favoritesResult.data ?? [];
            return favorites.length ? (
              <ResponsiveAssetListAuto>
                {favorites.map((asset, i) => {
                  return (
                    <AssetCard
                      key={asset.manageAsset.vbid}
                      asset={asset}
                      lazyLoad={i > 20}
                      ref={i === 0 ? firstCardRef : undefined}
                      hideOnReturn={false}
                    />
                  );
                })}
              </ResponsiveAssetListAuto>
            ) : (
              <FavoritesEmpty />
            );
          }}
        </Await>
      </React.Suspense>
    </DefaultTemplate>
  );
}
